var _path, _path2, _g, _path3, _rect, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmailVerification(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 288,
    height: 180,
    viewBox: "0 0 288 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1457_26378)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1457_26378)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M214.78 63.4782C214.78 63.4782 208.012 10.5182 168.08 48.5941C116.89 97.4018 82.4809 0.395489 44.5068 39.9925C23.7608 61.6241 78.5819 110.003 41.9691 135.463C5.35639 160.923 35.2756 179.983 35.2756 179.983H243.172C243.172 179.983 264.694 181.537 266.323 154.304C267.95 127.071 242.932 126.741 258.459 92.6614C273.986 58.5818 219.659 85.1698 214.78 63.4782Z",
    fill: "#E3F2FF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1457_26378",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 23,
    y: 30,
    width: 244,
    height: 150
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M214.78 63.4782C214.78 63.4782 208.012 10.5182 168.08 48.5941C116.89 97.4018 82.4809 0.395489 44.5068 39.9925C23.7608 61.6241 78.5819 110.003 41.9691 135.463C5.35639 160.923 35.2756 179.983 35.2756 179.983H243.172C243.172 179.983 264.694 181.537 266.323 154.304C267.95 127.071 242.932 126.741 258.459 92.6614C273.986 58.5818 219.659 85.1698 214.78 63.4782Z",
    fill: "#E3F2FF"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1457_26378)"
  }, /*#__PURE__*/React.createElement("rect", {
    opacity: 0.45,
    x: 110.879,
    y: 27.3594,
    width: 115.2,
    height: 102.24,
    fill: "url(#paint0_linear_1457_26378)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M104.559 136.515H232.6L227.927 143.429C227.74 143.707 227.426 143.873 227.091 143.873H110.067C109.732 143.873 109.419 143.707 109.231 143.429L104.559 136.515Z",
    fill: "url(#paint1_linear_1457_26378)"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.45,
    x: 97.1992,
    y: 133.571,
    width: 142.758,
    height: 1.47173,
    fill: "url(#paint2_linear_1457_26378)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114.125,
    y: 36.4365,
    width: 108.908,
    height: 2.2076,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114.125,
    y: 43.7959,
    width: 108.908,
    height: 2.2076,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114.125,
    y: 51.1543,
    width: 108.908,
    height: 2.2076,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114.125,
    y: 58.5127,
    width: 108.908,
    height: 2.2076,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114.125,
    y: 65.8721,
    width: 108.908,
    height: 2.2076,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114.125,
    y: 73.2295,
    width: 108.908,
    height: 2.2076,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114.125,
    y: 80.5889,
    width: 108.908,
    height: 2.2076,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114.125,
    y: 87.9473,
    width: 108.908,
    height: 2.2076,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114.125,
    y: 95.3057,
    width: 108.908,
    height: 2.2076,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114.125,
    y: 40.1162,
    width: 108.908,
    height: 2.2076,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114.125,
    y: 47.4746,
    width: 108.908,
    height: 2.2076,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114.125,
    y: 54.833,
    width: 108.908,
    height: 2.2076,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114.125,
    y: 62.1924,
    width: 108.908,
    height: 2.2076,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114.125,
    y: 69.5508,
    width: 108.908,
    height: 2.2076,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114.125,
    y: 76.9092,
    width: 108.908,
    height: 2.2076,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114.125,
    y: 84.2686,
    width: 108.908,
    height: 2.2076,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114.125,
    y: 91.626,
    width: 108.908,
    height: 2.2076,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114.125,
    y: 98.9854,
    width: 108.908,
    height: 2.2076,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 118.538,
    y: 36.4365,
    width: 0.735867,
    height: 74.3226,
    fill: "url(#paint3_linear_1457_26378)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.582 110.528C117.582 110.249 117.808 110.023 118.087 110.023H119.726C120.005 110.023 120.231 110.249 120.231 110.528V112.432H117.582V110.528Z",
    fill: "url(#paint4_linear_1457_26378)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.808 112.786C116.874 112.576 117.069 112.433 117.29 112.433H120.523C120.743 112.433 120.938 112.576 121.004 112.786L122.011 115.991C122.114 116.316 121.871 116.647 121.53 116.647H116.282C115.942 116.647 115.699 116.316 115.801 115.991L116.808 112.786Z",
    fill: "url(#paint5_linear_1457_26378)"
  })))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M110.88 137.52L143.727 113.227C144.745 112.474 146.135 112.474 147.152 113.227L180 137.52V162H110.88V137.52Z",
    fill: "#2743AD"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 122.4,
    y: 118.801,
    width: 46.08,
    height: 41.76,
    rx: 2.88,
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M146.48 148.24C153.019 148.24 158.32 142.939 158.32 136.4C158.32 129.861 153.019 124.561 146.48 124.561C139.941 124.561 134.641 129.861 134.641 136.4C134.641 142.939 139.941 148.24 146.48 148.24Z",
    fill: "#FEA21E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M141.508 136.637L144.705 139.834L151.453 133.085",
    fill: "url(#paint6_linear_1457_26378)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M141.508 136.637L144.705 139.834L151.453 133.085",
    stroke: "white",
    strokeWidth: 1.44,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M110.88 137.52L180 179.28H110.88V137.52Z",
    fill: "#91CAFF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M180 137.52L114.84 179.28H180V137.52Z",
    fill: "#2D87F3"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M174.204 167.76H162.72V172.851H174.204V167.76Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M174.204 167.76H171.585V172.851H174.204V167.76Z",
    fill: "url(#paint7_linear_1457_26378)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M188.765 128.273C188.765 127.399 188.057 126.691 187.183 126.691H186.979C185.993 126.691 185.193 125.892 185.193 124.905V124.65C185.193 123.805 184.508 123.119 183.662 123.119C182.817 123.119 182.132 123.805 182.132 124.65V124.905C182.132 125.892 181.332 126.691 180.346 126.691H180.141C179.268 126.691 178.56 127.399 178.56 128.273C178.56 129.147 179.268 129.855 180.141 129.855H180.346C181.332 129.855 182.132 130.655 182.132 131.641V131.896C182.132 132.742 182.817 133.427 183.662 133.427C184.508 133.427 185.193 132.742 185.193 131.896V131.641C185.193 130.655 185.993 129.855 186.979 129.855H187.183C188.057 129.855 188.765 129.147 188.765 128.273Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M136.885 108.804C136.885 108.057 136.279 107.452 135.532 107.452H135.358C134.515 107.452 133.831 106.768 133.831 105.925V105.707C133.831 104.984 133.245 104.398 132.522 104.398C131.8 104.398 131.214 104.984 131.214 105.707V105.925C131.214 106.768 130.53 107.452 129.687 107.452H129.512C128.766 107.452 128.16 108.057 128.16 108.804C128.16 109.551 128.766 110.157 129.512 110.157H129.687C130.53 110.157 131.214 110.84 131.214 111.683V111.901C131.214 112.624 131.8 113.21 132.522 113.21C133.245 113.21 133.831 112.624 133.831 111.901V111.683C133.831 110.84 134.515 110.157 135.358 110.157H135.532C136.279 110.157 136.885 109.551 136.885 108.804Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M110.414 126.883C110.414 126.245 109.897 125.728 109.259 125.728H109.11C108.389 125.728 107.805 125.144 107.805 124.424V124.237C107.805 123.62 107.305 123.119 106.687 123.119C106.07 123.119 105.569 123.62 105.569 124.237V124.424C105.569 125.144 104.985 125.728 104.264 125.728H104.115C103.477 125.728 102.96 126.245 102.96 126.883C102.96 127.522 103.477 128.039 104.115 128.039H104.264C104.985 128.039 105.569 128.623 105.569 129.343V129.53C105.569 130.147 106.07 130.648 106.687 130.648C107.305 130.648 107.805 130.147 107.805 129.53V129.343C107.805 128.623 108.389 128.039 109.11 128.039H109.259C109.897 128.039 110.414 127.522 110.414 126.883Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M180.254 99.5231C180.254 98.885 179.737 98.3677 179.099 98.3677H178.949C178.229 98.3677 177.645 97.7837 177.645 97.0633V96.8769C177.645 96.2594 177.144 95.7588 176.527 95.7588C175.909 95.7588 175.409 96.2594 175.409 96.8769V97.0633C175.409 97.7837 174.825 98.3677 174.104 98.3677H173.955C173.317 98.3677 172.8 98.885 172.8 99.5231C172.8 100.161 173.317 100.679 173.955 100.679H174.104C174.825 100.679 175.409 101.263 175.409 101.983V102.169C175.409 102.787 175.909 103.287 176.527 103.287C177.144 103.287 177.645 102.787 177.645 102.169V101.983C177.645 101.263 178.229 100.679 178.949 100.679H179.099C179.737 100.679 180.254 100.161 180.254 99.5231Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M166.32 110.158C166.32 109.67 165.924 109.274 165.436 109.274H165.302C164.75 109.274 164.304 108.828 164.304 108.276V108.142C164.304 107.665 163.917 107.278 163.44 107.278C162.962 107.278 162.576 107.665 162.576 108.142V108.276C162.576 108.828 162.129 109.274 161.578 109.274H161.444C160.955 109.274 160.56 109.67 160.56 110.158C160.56 110.647 160.955 111.042 161.444 111.042H161.578C162.129 111.042 162.576 111.489 162.576 112.04V112.174C162.576 112.651 162.962 113.038 163.44 113.038C163.917 113.038 164.304 112.651 164.304 112.174V112.04C164.304 111.489 164.75 111.042 165.302 111.042H165.436C165.924 111.042 166.32 110.647 166.32 110.158Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1457_26378",
    x1: 3.95891,
    y1: 241.199,
    x2: 99.6566,
    y2: -3.68488,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5D2EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#F1F7FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1457_26378",
    x1: 8.20723,
    y1: 134.272,
    x2: 65.1489,
    y2: 261.194,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5D2EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#F1F7FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1457_26378",
    x1: 115.948,
    y1: 133.597,
    x2: 116.772,
    y2: 146.801,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0BBCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D9EB7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1457_26378",
    x1: 117.984,
    y1: 13.7858,
    x2: 119.857,
    y2: 13.7879,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B8C5E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#C9D8E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1457_26378",
    x1: 117.93,
    y1: 110.065,
    x2: 121.746,
    y2: 110.759,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0BBCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D9EB7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1457_26378",
    x1: 116.464,
    y1: 112.506,
    x2: 125.697,
    y2: 114.902,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0BBCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D9EB7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1457_26378",
    x1: 146.48,
    y1: 133.085,
    x2: 146.48,
    y2: 139.834,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB52E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E69603"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1457_26378",
    x1: 169.614,
    y1: 166.208,
    x2: 176.535,
    y2: 166.664,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5D2EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#F1F7FE"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1457_26378"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 288,
    height: 180,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1457_26378"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 242.863,
    height: 149.835,
    fill: "white",
    transform: "translate(23.7598 30.2393)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailVerification);
export default __webpack_public_path__ + "static/media/Email Verification.8e5900d8e3165f1775b6adcf87252aa7.svg";
export { ForwardRef as ReactComponent };